import { Component, ViewChild } from '@angular/core';
import { ProjectService } from '../../_core/services/project.service';
import { ProfileService } from '../../_core/services/profile.service';
import { ProjectSpecification } from '../../_core/models/project-specification.model';
import { ToolboxItemService } from '../../_core/services/toolbox-item.service';
import { CrmService } from 'src/app/_core/services/crm.service';
import { OfferComponent } from '../offer/offer.component';

@Component({
	selector: 'app-offer-popup',
	templateUrl: './offer-popup.component.html',
	styleUrls: ['./offer-popup.component.css']
})
export class OfferPopupComponent {
	@ViewChild(OfferComponent) offerComponent: OfferComponent;
	isPopupShown: boolean = false;
	isStatusDialogOpened: boolean = false;
	statusDialogMessage: string = "";

	get exportButtonLabel(): string {
		if (this.projectService.draftMode) {
			return $localize`:Toolbar|'Export BOM' button disabled tooltip:Export to ERP is disabled in test mode`;
		}
		else if (this.projectService.isValid) {
			if((this.projectService.readOnly && this.crmService.isCrmPresent) || !this.crmService.isCrmPresent){
				return $localize`:Toolbar|'Export BOM' button tooltip:Export to ERP`;
			} else {
				return $localize`:Toolbar|'Export BOM' button tooltip:Project is editable, export is disabled`;
			}
		} else {
			return $localize`:Toolbar|'Export BOM' button disabled tooltip:Project is not valid, export is disabled`;
		}
	}

	dialogTitle = $localize`:BOM|'Include in offer' header:Include in offer`;

	constructor(
		private profileService: ProfileService,
		public projectService: ProjectService,
		public toolBSrvc: ToolboxItemService,
		public crmService: CrmService) {
	}

	projectSpecification = new ProjectSpecification(this.profileService);

	public togglePopup(show?: boolean): void {
		const s = show !== undefined ? show : !this.isPopupShown;
		this.isPopupShown = s;
	}

	public action(status: boolean) {
		this.togglePopup(false);
		if (status) {
			this.offerComponent.changeElements("inOffer");
			this.projectService.emitChange();
		}	
	}

}
